import { render, staticRenderFns } from "./marketTradeAmount.vue?vue&type=template&id=920317c0&scoped=true&"
import script from "./marketTradeAmount.vue?vue&type=script&lang=js&"
export * from "./marketTradeAmount.vue?vue&type=script&lang=js&"
import style0 from "./marketTradeAmount.vue?vue&type=style&index=0&id=920317c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920317c0",
  null
  
)

export default component.exports